import { CookieKey, useCookie } from '@src/modules/cookie';
import { isServer } from '@src/utils/isServer';

type ABTestingValue = 'A' | 'B';

export const checkVersionInString = (str: string | undefined, version: ABTestingValue): boolean =>
    !!str?.endsWith(version);

export const getVersionInString = (str?: string): ABTestingValue | undefined => {
    const matched = str?.match(/_(A|B)$/);

    return matched?.[1] as ABTestingValue;
};
if (process.env.NODE_ENV === 'development' && !isServer) {
    import('@src/modules/cookie').then(({ Cookie }) => {
        // @ts-ignore
        window.setABTest = (ab: ABTestingValue) => {
            const matched = Cookie.get().AB_MICROCREDIT?.match(/(.*?_)(A|B)$/);
            Cookie.set(CookieKey.AB_MICROCREDIT, (matched?.[1] ?? '_') + ab);
        };
    });
}

export const useABTest = (): boolean => useCookie((cookie) => getVersionInString(cookie.AB_MICROCREDIT)) === 'B';

export const addToLink = (value: ABTestingValue | undefined, prefix: string): string => {
    if (value === 'B' || value === 'A') {
        return `${prefix}_${value.toLocaleLowerCase()}`;
    }

    return prefix;
};
